import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { defaultFormData, initialState } from "./initialState";
import { IData, IFormData, OrderStatusType } from "../types";
import { DateTime } from "luxon";
import { set } from "lodash";

export const useOrderSlice = createSlice({
  name: "orderState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },

    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction< OrderStatusType>) => {
      state.filter = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },

    setOrderDir: (state, action: PayloadAction<string>) => {
      state.orderDir = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },
    setEndDate: (state, action: PayloadAction<DateTime | null>) => {
      state.endDate = action.payload;
    },
    setStartDate: (state, action: PayloadAction<DateTime | null>) => {
      state.startDate = action.payload;
    },

    doUpdateStatus: (
      state,
      action: PayloadAction<{
        id: string;
        action: OrderStatusType;
        callback: () => void;
      }>
    ) => {},

    setPackageItemHold: (
      state,
      action: PayloadAction<{
        id: string;
      }>
    ) => {
      const { id } = action.payload;
      const index = state.holdItems.findIndex((item) => item === id);
      if (index !== -1) {
        state.holdItems.splice(index, 1);
      } else {
        state.holdItems.push(id);
      }
    },

    doGetById: (state, action: PayloadAction<string>) => {
      state.loading = true;
    },
    clearFrom: (state) => {
      state.formData = { ...defaultFormData };
    },
    doGetList: (state) => {
      state.loading = true;
    },

    setList: (state, action: PayloadAction<Array<IData>>) => {
      state.list = action.payload;
    },
    setDataForm: (state, action: PayloadAction<IFormData>) => {
      state.formData = action.payload;
    },
    updateShippingFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `shippingForm.${action.payload.key}`, action.payload.value);
    },
    clearShippingForm: (
      state,
    ) => {
      state.shippingForm = initialState.shippingForm;
    },
    
  },
});

export const { reducer, actions, name: sliceKey } = useOrderSlice;
